import PropTypes from 'prop-types';
import NImage from '@base/Image';
import {
  AboutUnacademyContainer,
  AboutTitle,
  AboutBlock,
  AboutContentContainer,
  AboutContentTitle,
  AboutContentSubTitle,
  AboutImageContainer
} from './styles';

const AboutCard = ({ _resource }) => {
  return (
    <AboutBlock key={_resource.id}>
      <AboutImageContainer>
        <NImage
          src={_resource.url.default}
          alt={_resource.title}
          layout="fill"
        />
      </AboutImageContainer>
      <AboutContentContainer>
        <AboutContentTitle>{_resource.title}</AboutContentTitle>
        <AboutContentSubTitle>{_resource.subTitle}</AboutContentSubTitle>
      </AboutContentContainer>
    </AboutBlock>
  );
};

const AboutUnacademy = ({ features }) => {
  const { title, resources } = features;
  return (
    <AboutUnacademyContainer>
      <AboutTitle>{title}</AboutTitle>
      {resources.map((_resource) => (
        <AboutCard key={_resource.id} _resource={_resource} />
      ))}
    </AboutUnacademyContainer>
  );
};

AboutUnacademy.propTypes = {
  features: PropTypes.objectOf(PropTypes.any).isRequired
};

export default AboutUnacademy;
